const EASTERN_TZ = 'America/New_York';

/** Formats a UTC/ISO timestamp as Eastern date + hour:minute, e.g. Aug 10, 2026, 4:30 PM */
export function formatEasternDateTime(value: string | Date | null | undefined): string {
  if (!value) {
    return '';
  }

  const date = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return new Intl.DateTimeFormat('en-US', {
    timeZone: EASTERN_TZ,
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).format(date);
}
